import { ApiService } from "./ApiService.js";

export class DataService extends ApiService {

    constructor(servicePath, authManager, options = {}) {

        super(servicePath, authManager, options);

    };

    async call(method, path, data, options) {

        options = Object.assign({
            contentType: 'json',
            responseType: 'json',
            anonymous: false,
        }, options || {});


        try {

            const response = await super.call(method, path, data, options);
            const payload = response.payload;
            const payloadData = (payload && payload.type && payload[payload.type]) || null;

            return payloadData;

        } catch (error) {

            let errorDetails = {};

            if (error.payload) {
                if (error.payload.error) {
                    errorDetails = error.payload.error;
                } else {
                    if (error.payload.code)
                        errorDetails.code = error.payload.code;
                    if (error.payload.message)
                        errorDetails.message = error.payload.message;
                }
            } else {
                errorDetails = {
                    code: error.status,
                    message: error.statusText,
                }
            }

            const err = new Error("RemoteDataService call error");
            err.details = errorDetails;

            throw err;

        };

    };

    async get(url, data, params) {

        return this.call('GET', url, data, params);

    };

    async put(url, data, params) {

        return this.call('PUT', url, data, params);

    };

    async post(url, data, params) {

        return this.call('POST', url, data, params);

    };

    async delete(url, data, params) {

        return this.call('DELETE', url, data, params);

    };

    // --------------------------------------------------------------------------------------------

}
